export { default } from './ExternalPageRedirect';
